import React, { useState, useEffect, Fragment } from "react";
import { withRouter } from "react-router";
import { useSelector,useDispatch } from "react-redux";
import {setUnsurEdit} from "../actions"
import { withStyles } from "@material-ui/core/styles";
import { doGet, doPost,doPut } from "../services/api-service";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import Select from "react-select";


const PaMasterCreateComponent = props => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user.user)
    const master_to_edit = useSelector(state => state.assessment.master_to_edit)
    
    const [status, setStatus] = useState(true);
    const [withCustomAspek, setWithCustomAspek] = useState(false)
    const [name, setName] = useState("");
    const [note, setNote] = useState("");
    const [aspeks, setAspeks] = useState([]);
    const [aspekOption, setAspekOption] = useState([]);
    const [bobotAspek, setBobotAspek] = useState([]);
    const [dataSubAspek, setDataSubAspek] = useState([]);
    const [bobotSubAspek, setBobotSubAspek] = useState([]);
    const [dataUnsur, setDataUnsur] = useState([]);
    const [bobotUnsur, setBobotUnsur] = useState([]);
    const [bobotAtasan, setBobotAtasan] = useState(0);
    const [bobotBawahan, setBobotBawahan] = useState(0);
    const [error, setError] = useState("");
    const { classes } = props;
    
    useEffect(() => {
        getAspekOption();
    }, []);
    
       

    const getMasterDetail = async (master) => {

        const params = {};
        const response = await doGet("pa/master/"+master.id, params);
        if(response && response.data){


            let master = response.data
            setName(master.name) 
            setNote(master.note)            
            setWithCustomAspek(master.custom_aspek===1)
            setBobotAtasan(master.bobot_atasan)
            setBobotBawahan(master.bobot_bawahan)
            setStatus(master.status_code===1)
            const dataAspeksForSelect = master.aspeks.map(aspek => ({
                ...aspek,
                value: aspek.id,
                label: `${aspek.code} - ${aspek.name} (${aspek.note})`
            }));
            setAspeks(dataAspeksForSelect);
            setBobotUnsur(master.bobot_unsurs.map(bu=>({
                is_custom:bu.is_custom,
                sub_aspek_id:bu.sub_aspek_id,
                unsur_id:bu.id,
                bobot:bu.bobot
            })))
            
            let bobotSubAspeks = 
            master.sub_aspeks.map(subAspek=>{
                let sumBobotUnsur = 0
                    master.bobot_unsurs.forEach(
                        (item, index)=>{
                            if(subAspek.id === item.sub_aspek_id){
                                sumBobotUnsur += parseFloat(item.bobot)
                            }        
                        }
                    )
                    return{
                        aspek_id:subAspek.aspek_id,
                        sub_aspek_id:subAspek.id,
                        bobot:sumBobotUnsur
                    } 
            })
            
            let bobotAspeks = 
            dataAspeksForSelect.map(aspek=>{
                let sumBobotUnsur = 0
                    master.bobot_unsurs.forEach(
                        (item, index)=>{
                            if(aspek.id === item.aspek_id){
                                sumBobotUnsur += parseFloat(item.bobot)
                            }        
                        }
                    )
                    return{
                        aspek_id:aspek.id,
                        bobot:sumBobotUnsur
                    } 
            })
             
            
            
            setBobotSubAspek(bobotSubAspeks)            
            
            setBobotAspek(bobotAspeks)
            
        }
            
    }


    // useEffect(() => {

    //     if (aspeks.length > 0 ) { 

    //         console.log("bobotAspek", bobotAspek)
    //         console.log("aspeks", aspeks)

    //         const bobots = aspeks.map(aspek => {
    //             // Cari bobot yang sesuai dengan aspek_id
    //             const foundBobot = bobotAspek.find(b => b.aspek_id === aspek.id);
                
    //             return {
    //                 aspek_id: aspek.id,
    //                 bobot: foundBobot ? foundBobot.bobot : 0
    //             };
    //         });

    //         // const bobots = aspeks.map(aspek => ({
    //         //     aspek_id: aspek.value,
    //         //     bobot: 0
    //         // }));


    //         // if(!master_to_edit){   
    //             setBobotAspek(bobots);
    //         // }else{
    //         //     getMasterDetail(aspeks)
    //         // }

    //         getDataSubAspek(aspeks.map(aspek => aspek.value));

    //     } else {
            
    //         setBobotAspek([]);
    //     }
    // }, [aspeks.length,bobotAspek.length]);
    
    useEffect(() => {
        if (aspeks.length > 0) {           
            
            // const bobots = aspeks.map(aspek => ({
            //     aspek_id: aspek.value,
            //     bobot: 0
            // }));

            const bobots = aspeks.map(aspek => {
                // Cari bobot yang sesuai dengan aspek_id
                const foundBobot = bobotAspek.find(b => b.aspek_id === aspek.value);
                
                return {
                    aspek_id: aspek.value,
                    bobot: foundBobot ? foundBobot.bobot : 0
                };
            });
            

            // if(!master_to_edit){   
                setBobotAspek(bobots);
            // }else{
            //     getMasterDetail(aspeks)
            // }

            getDataSubAspek(aspeks.map(aspek => aspek.value));
        } else {
            
            setBobotAspek([]);
        }
    }, [aspeks.length]);

   
    const getAspekOption = async () => {
        const params = {is_custom:0, is_active:1};
        const response = await doGet("pa/aspek", params);
        if (response&&response.data&&response.data.length > 0) {
            const dataForSelect = response.data.map(aspek => ({
                ...aspek,
                value: aspek.id,
                label: `${aspek.code} - ${aspek.name} (${aspek.note})`
            }));
            setAspekOption(dataForSelect);            
        }
    };

    const getDataSubAspek = async aspek_ids => {
        const params = { aspek_ids: aspek_ids };
        const response = await doGet("pa/subaspek", params);
        if (response&&response.data&&response.data.length > 0) {
            const dataSubAspek = response.data.map(row => ({
                aspek_id: row.aspek_id,
                id: row.id,
                name: row.name,
                code: row.code
            }));
            
            setDataSubAspek(dataSubAspek);

            const bobotSubAspeks = dataSubAspek.map(subAspek => ({
                aspek_id: subAspek.aspek_id,
                sub_aspek_id: subAspek.id,
                bobot: 0
            })); 
            
            if(!master_to_edit){   
                         
                
                setBobotSubAspek(bobotSubAspeks);
            }else{
   
                
                let filteredData = [];
                if (bobotSubAspek.length > 0) {
                    const data1Set = new Set(bobotSubAspek.map(item => `${item.aspek_id}-${item.sub_aspek_id}`));
                
                    // Filter data2 untuk mendapatkan data yang tidak ada di data1
                    filteredData = bobotSubAspeks.filter(item => {
                        const key = `${item.aspek_id}-${item.sub_aspek_id}`;
                        return !data1Set.has(key);
                    });
                }else{
                    filteredData = [];
                }

                if (filteredData.length > 0) {

                    // Tambahkan filteredData ke bobotSubAspek yang sudah ada
                    setBobotSubAspek(prevState => [...prevState, ...filteredData]);
                }
                
            }

            getDataUnsur(dataSubAspek.map(subaspek => subaspek.id));
        }
    };

    const getDataUnsur = async sub_aspek_ids => {
        const params = { sub_aspek_ids: sub_aspek_ids };
        const response = await doGet("pa/unsur", params);
        if (response&&response.data&&response.data.length > 0) {
            const dataUnsur = response.data.map(row => ({
                sub_aspek_id: row.sub_aspek_id,
                id: row.id,
                name: row.name,
                code: row.code,
                is_custom:row.is_custom
            }));
            setDataUnsur(dataUnsur);

          
            const bobotUnsurs = dataUnsur.map(unsur => ({
                is_custom:unsur.is_custom,
                sub_aspek_id: unsur.sub_aspek_id,
                unsur_id: unsur.id,
                bobot: 0
            }));
            if(!master_to_edit){
               
                setBobotUnsur(bobotUnsurs);
            }else{
               

                let filteredData = []; 

                if (bobotUnsur.length > 0) {
                // Buat set untuk menyimpan semua unsur_id dari data1
                const data1Set = new Set(bobotUnsur.map(item => item.unsur_id));
    
                // Filter data2 untuk mendapatkan item yang unsur_id-nya tidak ada di data1
                 filteredData = bobotUnsurs.filter(item => !data1Set.has(item.unsur_id));
                }else{
                 filteredData = [];
                }
    
                // setBobotUnsur(bobotUnsurs);

                setBobotUnsur(prevState => [...prevState, ...filteredData]);
            }       
        }
    };

    const clear = () => {
        setStatus(true);
    };



    const cancel = () => {
        props.history.goBack();
    };



    const bobotAtasanChange = e => {
        setBobotAtasan(e.target.value);
        setBobotBawahan(100 - e.target.value);
    };

    const bobotBawahanChange = e => {
        setBobotBawahan(e.target.value);
        setBobotAtasan(100 - e.target.value);
    };

    const statusChange = e => {
        setStatus(!status);
    };

    const withCustomAspekChange = e => {        
        setWithCustomAspek(!withCustomAspek);
    };

    const nameChange = e => {
        setName(e.target.value);
    };

    const noteChange = e => {
        setNote(e.target.value);
    };

    const aspeksChange = e => {
        setAspeks(e);
    };



    const bobotUnsurChange = (unsur_id, e) => {

     
        const newValue = parseFloat(e.target.value);
        let currentOldBobot = bobotUnsur.filter(
            bobot => bobot.unsur_id === unsur_id
        )[0];

        if(currentOldBobot){

            const newBobot = { ...currentOldBobot, bobot: newValue };
            let otherOldBobots = bobotUnsur.filter(
                bobot => bobot.unsur_id !== unsur_id
            );
            const newBobotUnsurs = [...otherOldBobots, newBobot];
            setBobotUnsur(newBobotUnsurs);
                
            const allBobotUnsurInSubAspek = newBobotUnsurs.filter(
                bobot => bobot.sub_aspek_id === currentOldBobot.sub_aspek_id
            );

            const sumAllBobotUnsurInSubAspek = allBobotUnsurInSubAspek.reduce(
                (acc, current) => acc + parseFloat(current.bobot),
                0
            );

            let currentOldBobotSubAspek = bobotSubAspek.filter(
                bs => bs.sub_aspek_id === currentOldBobot.sub_aspek_id
            )[0];

            const newBobotSubAspek = {
                ...currentOldBobotSubAspek,
                bobot: sumAllBobotUnsurInSubAspek
            };

            
            let otherOldBobotSubAspeks = bobotSubAspek.filter(
                bs => bs.sub_aspek_id !== currentOldBobot.sub_aspek_id
            );

            const newBobotSubAspeks = [...otherOldBobotSubAspeks, newBobotSubAspek];
            
            setBobotSubAspek(newBobotSubAspeks);

            
            const allBobotSubAspekInAspek = newBobotSubAspeks.filter(
                bs => bs.aspek_id === currentOldBobotSubAspek.aspek_id
            );

            const sumAllBobotSubAspekInAspek = allBobotSubAspekInAspek.reduce(
                (acc, current) => acc + parseFloat(current.bobot),
                0
            );

            let currentOldBobotAspek = bobotAspek.filter(
                ba => ba.aspek_id === currentOldBobotSubAspek.aspek_id
            )[0];

            const newBobotAspek = {
                ...currentOldBobotAspek,
                bobot: sumAllBobotSubAspekInAspek
            };

            let otherOldBobotAspeks = bobotAspek.filter(
                ba => ba.aspek_id !== currentOldBobotSubAspek.aspek_id
            );

            const newBobotAspeks = [...otherOldBobotAspeks, newBobotAspek];
            
            setBobotAspek(newBobotAspeks);
        }
            
    };

    const submit = async() => {
        let inputValid = true;
        setError("");

        if(name.trim().length<1){
            setError("Please fill the name field");
            inputValid = false; return
        }

        // if(bobotAtasan==0 || bobotBawahan==0){
        //     setError("Please specify bobot for leader or staff ");
        //     inputValid = false; return
        // }

        const totalBobot = bobotAspek.reduce(
            (acc, current) => acc + current.bobot,
            0
        );

        if(totalBobot>100 || totalBobot == 0){
            inputValid = false;
            setError("Minimum total bobot is 1 and maximum is 100");
            return
        }else{
            if(!withCustomAspek && totalBobot!==100){
                inputValid = false;
                setError("If you only use fixed aspek, total bobot must be equal to 100");
                return
            }
            if(withCustomAspek && totalBobot===100){
                inputValid = false;
                setError("If this master need customized aspek, total bobot must be less than 100");
                return
            }
        }

        if(inputValid){
            
            if (aspeks.length > 0) {
                const params = {                    
                    aspek_ids: aspeks.map(a => a.value),
                    bobot_atasan: bobotAtasan,
                    bobot_bawahan: bobotBawahan,
                    bobot_unsurs: bobotUnsur,
                    custom_aspek:withCustomAspek?1:0,
                    name: name,
                    note: note,
                    status: status == true ? 1 : 0,
                    creator: user.emp_id
                };
                if(master_to_edit){
                    const editParams = {...params, id:master_to_edit.id}
                    await doPut("pa/master", editParams, "update pa master");
                }else{
                    await doPost("pa/master", params, "save pa master");
                }
                
            }

            clear();
            if(withCustomAspek){
                props.history.push("/pa/app/aspek/create")
            }else{
                props.history.goBack();
            }

        }

    };

   

    useEffect(() => {
        if(master_to_edit){
            getMasterDetail(master_to_edit)
        }
    }, [master_to_edit])

    const customAspekLabel = withCustomAspek===true?"Need customized aspek from Leader of departments" : "Fixed aspeks only"

    return (
        <Grid container direction="column">
            <Grid item xs={8} container>
                <Grid item xs={12}>
                    <Typography
                        variant="h6"
                        gutterBottom
                        className="animated slideInLeft"
                    >
                        Create New PA Master
                    </Typography>
                </Grid>

                <Grid container>
                    <TextField
                        id="Name"
                        label="Name"
                        value={name}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={nameChange}
                    />
                </Grid>

                <Grid container>
                    <TextField
                        id="Note"
                        label="Note"
                        value={note}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        onChange={noteChange}
                    />
                </Grid>

                <Grid container justify="space-between" className={classes.marginTops}>
                    <Grid item xs={5}>
                        <TextField
                            fullWidth
                            id="bobotAtasan"
                            type="number"
                            margin="dense"
                            label="Leader bobot"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{
                                min: "0",
                                max: "100",
                                step: "1"
                            }}
                            onChange={bobotAtasanChange}
                            value={bobotAtasan}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <TextField
                            fullWidth
                            id="bobotBawahan"
                            type="number"
                            margin="dense"
                            label="Staff bobot"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{
                                min: "0",
                                max: "100",
                                step: "1"
                            }}
                            onChange={bobotBawahanChange}
                            value={bobotBawahan}
                        />
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={status}
                                onChange={statusChange}
                                color="primary"
                                inputProps={{
                                    "aria-label": "primary checkbox"
                                }}
                            />
                        }
                        label={status ? "active" : "inactive"}
                        />
                    </Grid>

                        <Grid item>
                            <FormControlLabel
                            control={
                            <Switch
                                    checked={withCustomAspek}
                                    onChange={withCustomAspekChange}
                                    color="primary"
                                    />
                                    }
                                    label={customAspekLabel}
                                />
                        </Grid>
                </Grid>

                <Grid item xs={12} className={classes.marginTops}>
                    <Select
                        isMulti
                        value={aspeks}
                        options={aspekOption}
                        onChange={aspeksChange}
                        placeholder="Select Aspek"
                        styles={selectCustomZindex}
                    />
                </Grid>

                <Grid container className={classes.bobotContainer}>
                    {
                    aspeks &&
                        aspeks.map(aspek => {
                            if(aspek.is_custom===0){
                                return(
                                    <Grid
                                        key={aspek.id}
                                        container
                                        className={classes.aspek_container}
                                    >
                                        <Grid container className={classes.aspek_row}>
                                            <Grid item xs={1}>
                                                {aspek.code}
                                            </Grid>
                                            <Grid item xs={5}>
                                                {aspek.name}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={6}
                                                className={classes.aspek_score}
                                            >
                                                {bobotAspek.filter(bobot => bobot.aspek_id === aspek.id)[0] &&
                                                bobotAspek.filter(bobot =>bobot.aspek_id === aspek.id)[0].bobot}
                                                %
                                            </Grid>
                                        </Grid>
                                        {dataSubAspek
                                            .filter(s => s.aspek_id === aspek.id)
                                            .map(sub_aspek => (
                                                <Grid
                                                    key={sub_aspek.id}
                                                    container
                                                    className={classes.sub_aspek}
                                                >
                                                    <Grid
                                                        container
                                                        className={
                                                            classes.sub_aspek_row
                                                        }
                                                    >
                                                        <Grid item xs={1}>
                                                            {sub_aspek.code}
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            {sub_aspek.name}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={6}
                                                            className={
                                                                classes.sub_aspek_score
                                                            }
                                                        >
                                                            {bobotSubAspek.filter(bobot =>bobot.sub_aspek_id === sub_aspek.id)[0] &&
                                                            bobotSubAspek.filter(bobot =>bobot.sub_aspek_id ===sub_aspek.id)[0].bobot}
                                                            %
                                                        </Grid>
                                                    </Grid>
                                                    {dataUnsur
                                                        .filter(u =>u.sub_aspek_id ===sub_aspek.id)
                                                        .map(unsur => (
                                                            <Grid
                                                                key={unsur.id}
                                                                container
                                                                className={
                                                                    classes.unsur
                                                                }
                                                            >
                                                                <Grid
                                                                    container
                                                                    className={
                                                                        classes.unsur_row
                                                                    }
                                                                    alignItems="center"
                                                                >
                                                                    <Grid item xs={1}>
                                                                        {unsur.code}
                                                                    </Grid>
                                                                    <Grid item xs={7}>

                                                                    {unsur.name.split('\n').map((item, key) => {
                                                                        return <Fragment key={key}>{item}<br/></Fragment>
                                                                    })}

                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        container
                                                                        xs={4}
                                                                        justify="flex-end"
                                                                    >
                                                                        <Grid
                                                                            item
                                                                            xs={5}
                                                                        >
                                                                            <TextField
                                                                                id="outlined-number"
                                                                                type="number"
                                                                                margin="dense"
                                                                                InputLabelProps={{
                                                                                    shrink: true
                                                                                }}
                                                                                inputProps={{
                                                                                    min:
                                                                                        "0",
                                                                                    max:
                                                                                        "100",
                                                                                    step:
                                                                                        "1"
                                                                                }}
                                                                                onChange={(e) =>bobotUnsurChange(unsur.id,e)}
                                                                                value={
                                                                                    bobotUnsur.filter(bu =>bu.unsur_id ===unsur.id)[0] &&
                                                                                    bobotUnsur.filter(bu =>bu.unsur_id ===unsur.id)[0].bobot
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                </Grid>
                                            ))}
                                    </Grid>
                                )

                            }else{
                                return null
                            }
                        })
                
                }
                </Grid>
                <Grid container justify="space-between">
                    <Grid item className={classes.error}>
                    {error}
                    </Grid>
                    <Grid item className={classes.totalBobot}>
                        Total bobot{" "}
                        {bobotAspek.reduce(
                            (acc, current) => acc + current.bobot,
                            0
                        )}{" "}
                        %
                    </Grid>
                </Grid>
            </Grid>

            <Grid
                justify="flex-end"
                container
                className={classes.addAction}
                spacing={8}
            >
                <Grid item>
                    <Button variant="outlined" onClick={cancel}>
                        cancel
                    </Button>
                </Grid>

                <Grid item>
                    <Button
                        onClick={submit}
                        color="primary"
                        variant="contained"
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};



const styles = theme => ({
    marginTops: {
        marginTop: 10
    },
    container: {
        marginTop: -16,
        marginLeft: 5
    },
    marginOver: {
        marginTop: -25
    },
    score: {
        maxWidth: 50
    },
    sub_aspek: {
        paddingLeft: 10
    },
    unsur: {
        paddingLeft: 10
    },
    aspek_container: {
        border: "1px solid #c4c4c4",
        borderRadius:4,
        margin:"5px 0 5px 0"
    },
    aspek_row: {
        padding: 5,
        backgroundColor: "#d2fce4",
        borderBottom: "1px solid #c4c4c4"

    },
    aspek_score: {
        display: "flex",
        justifyContent: "flex-end",
        fontWeight: "bold",
        fontSize: 17,
        color: "red"
    },
    sub_aspek_row: {
        padding: 5,
        backgroundColor: "#7fcbfb",
        borderLeft: "1px solid #c4c4c4",
        borderBottom: "1px solid #c4c4c4"

    },
    sub_aspek_score: {
        display: "flex",
        justifyContent: "flex-end",
        fontWeight: "bold",
        fontSize: 13,
        color: "#000000"
    },
    unsur_row: {
        padding: 5,
        borderLeft: "1px solid #c4c4c4",
        borderBottom: "1px solid #c4c4c4"
    },
    unsur_score: {
        color: "white",
        display: "flex",
        justifyContent: "center"
    },
    unsur_score_value: {
        backgroundColor: "#b207e6",
        color: "white",
        display: "flex",
        justifyContent: "center",
        padding: 5
    },
    unsur_select: {
        backgroundColor: "#b207e6",
        color: "white",
        width: "100%",
        height: "100%",
        fontWeight: "bold"
    },
    bobotContainer: {
        marginTop: 20
    },
    totalBobot: {
        fontWeight: "bold",
        color: "red"
    },
    error:{
        color: "red"
    }
});

export const selectCustomZindex = {
    control: (base, state) => ({
        ...base,
        minWidth: "150px",
        margin: "0 4px"
    }),
    container: (base, state) => {
        return {
            ...base,
            flex: 1,
            zIndex: state.isFocused ? "1100" : "1" //Only when current state focused
        };
    }
};



export default withRouter(withStyles(styles)(PaMasterCreateComponent));
